module.exports = __webpack_public_path__ + "assets/8014aed2580abdf75edfc5789d3b5c28.svg";